import { APICore } from './apiCore'

const api = new APICore()

function getConfsRegistro (params) {
  const baseUrl = '/conf-registro'
  return api.get(baseUrl, params)
}

function getConfRegistro (id) {
  const baseUrl = `/conf-registro/${id}`
  return api.get(baseUrl, {})
}

function addConfRegistro (params) {
  const baseUrl = '/conf-registro'
  return api.createWithFile(baseUrl, params)
}

function updateConfRegistro (params) {
  const baseUrl = '/conf-registro'
  return api.updateWithFile(baseUrl, params)
}

function deleteConfRegistro (params) {
  const baseUrl = '/conf-registro'
  return api.delete(baseUrl, params)
}

export { getConfsRegistro, getConfRegistro, addConfRegistro, updateConfRegistro, deleteConfRegistro }
